let listening = false
let targets = []

class RallaxObj {
  static DEFAULT_OPTIONS = {
    speed: 0.3,
    mobilePx: false
  };

  constructor(target, {speed, mobilePx}) {
    this.speed = speed || RallaxObj.DEFAULT_OPTIONS.speed
    this.mobilePx = mobilePx || RallaxObj.DEFAULT_OPTIONS.mobilePx
    this.mobileDisable = false
    this.conditions = []
    this.active = true
    this.target = target

    if (typeof target === 'string') {
      this.target = document.querySelector(`${target}`)
    }

    this.winHeight = window.innerHeight
    this.accumulated = 0
    this.getRect()

    this.startScroll = this.targetR.top - this.winHeight > 0
      ? this.targetR.top - this.winHeight
      : 0
  }

  // API
  stop() {
    this.active = false
  }

  start() {
    this.active = true
  }

  getSpeed() {
    return this.speed
  }

  changeSpeed(newSpeed) {
    if (this.inWindow() && newSpeed !== this.speed) {
      this.accumulated = this.getTranslation()
      this.startScroll = this.scrollY()
    }
    this.speed = newSpeed
  }

  when(condition, action) {
    this.conditions.push({condition, action})
    return this
  }

  // HELPERS
  scrollY() {
    return window.scrollY || window.pageYOffset
  }

  getTranslation() {
    const dist = this.scrollY() - this.startScroll
    const translation = (dist * this.speed) + this.accumulated
    return translation;
  }

  getRect() {
    this.targetR = this.target.getBoundingClientRect()
    return this.targetR
  }

  inWindow() {
    this.getRect()
    const top = this.targetR.top
    const bottom = this.targetR.bottom

    return top < this.winHeight && bottom > 0
  }

  move() {
    this.target
      .style
      .transform = `translateY(${this.getTranslation()}px)`
  }
}

class Rallax {
  constructor() {
    this.targets = [];
    this.listening = false;
  }

  add(target, userOptions = {}) {
    const rallaxInst = new RallaxObj(target, userOptions);
    this.targets.push(rallaxInst);

    if (!this.listening) {
      this.listening = true;
      this.addListener();
    }

    return rallaxInst;
  }

  resize() {
    const newSize = window.innerWidth;
    this.targets.forEach(obj => {
      if (obj.mobilePx >= newSize) {
        obj.mobileDisable = true
      }
    });
  }

  addListener() {
    window.addEventListener('scroll', event => {
      this.controller(this.targets);
    })
    window.addEventListener('resize', event => {
      this.resize();
    })
  }


  controller(targets) {
    requestAnimationFrame(() => {
      targets.forEach(obj => {
        if (obj.mobileDisable) return

        obj.conditions
          .forEach(({condition, action}) => {
            if (condition()) action()
          })

        if (obj.active) {
          obj.move()
        }
      })
    })
  }
}